import { render, staticRenderFns } from "./PaginaContenido.vue?vue&type=template&id=11c82b14&scoped=true"
import script from "./PaginaContenido.vue?vue&type=script&lang=js"
export * from "./PaginaContenido.vue?vue&type=script&lang=js"
import style0 from "./PaginaContenido.vue?vue&type=style&index=0&id=11c82b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c82b14",
  null
  
)

export default component.exports